import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';
import { useAuth } from '../context/AuthContext';
import Intro from '../components/Intro/Intro';

export default function IntroPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [vistaOpen, setVistaOpen] = useState(false);
  const transitionStartedRef = useRef(false);

  // Already authenticated → go to lobby
  useEffect(() => {
    if (user) navigate('/lobby', { replace: true });
  }, [user, navigate]);

  const handleExplore = useCallback(() => {
    if (transitionStartedRef.current) return;
    transitionStartedRef.current = true;
    setVistaOpen(false);

    const destination = user ? '/lobby' : '/signup';
    const tl = gsap.timeline();

    tl.to('.soundvista_explore_link', {
      y: 20, opacity: 0, duration: 0.6, ease: 'power2.in',
    })
      .to('.soundvista_tagline', {
        opacity: 0, duration: 0.6, ease: 'power2.in',
      }, '<0.1')
      .to('.soundvista_imageWrapper', {
        scale: 1.3, filter: 'blur(8px)', opacity: 0,
        duration: 1.2, ease: 'power2.out',
        onComplete: () => navigate(destination, { replace: true }),
      }, '<0.2')
      .to('.soundvista_ask-vista-pill', {
        opacity: 0, y: 20, duration: 0.5, ease: 'power2.in',
      }, '<');
  }, [user, navigate]);

  useEffect(() => {
    if (user) return undefined;

    const autoAdvance = window.setTimeout(() => {
      handleExplore();
    }, 1800);

    return () => window.clearTimeout(autoAdvance);
  }, [handleExplore, user]);

  return (
    <div className="soundvista_scenewrapper bg-secondary">
      <Intro
        handleClickToExplore={handleExplore}
        vistaOpen={vistaOpen}
        onOpenVista={() => setVistaOpen(true)}
        onCloseVista={() => setVistaOpen(false)}
      />
    </div>
  );
}
